export default {
  lang: 'Deutsch',
  langCode: 'de',
  toolbar: {
    expand: 'Symbolleiste erweitern',
    collapse: 'Symbolleiste einklappen',
  },
  input: {
    placeholder: 'Modell-URL eingeben oder Dateien per Drag & Drop hier ablegen',
  },
  format: {
    auto: 'Auto-Erkennung',
  },
  btn: {
    add: 'Hinzufügen',
    clearAll: 'Alle löschen',
    resetView: 'Ansicht zurücksetzen',
    exportHTML: 'Als HTML exportieren',
    exportGLB: 'Modell exportieren (GLB)',
    exportAnnJSON: 'Beschriftungen exportieren (JSON)',
    exportZip: 'Paket exportieren (ZIP)',
    undo: 'Rückgängig',
    redo: 'Wiederholen',
    split: 'Teilen',
    restore: 'Wiederherstellen',
    measure: 'Messen',
    annotate: 'Beschriften',
    clear: 'Löschen',
    selectSplit: 'Modell zum Teilen wählen',
  },
  clip: {
    cut: 'Schneiden',
    xAxis: 'X-Achse',
    yAxis: 'Y-Achse',
    zAxis: 'Z-Achse',
    section: 'Querschnitt',
  },
  status: {
    idle: 'Bereit',
    loading: 'Modell wird geladen...',
    cleared: 'Alles gelöscht',
    loadSuccess: 'Erfolgreich geladen',
    loadFailed: 'Laden fehlgeschlagen',
    unsupportedFormat: 'Nur .stl / .obj / .ply / .gltf / .glb / .fbx / .step / .iges / .brep Formate unterstützt',
    loadingFile: 'Laden',
    noSplitParts: 'Modell hat keine teilbaren Komponenten',
    splitDone: 'In {count} Teile aufgeteilt',
    exporting: 'Exportieren...',
    exportSuccess: 'Export erfolgreich',
    exportFailed: 'Export fehlgeschlagen',
    annotationHint: 'Beschriftung hinzugefügt, Doppelklick zum Bearbeiten',
    noOriginalFile: 'Originaldatei nicht verfügbar, nur für lokal importierte Dateien',
  },
  model: {
    vertices: 'Vertices',
    faces: 'Flächen',
    part: 'Teil',
  },
  material: {
    steel: 'Stahl',
    stainless: 'Edelstahl',
    aluminum: 'Aluminium',
    titanium: 'Titan',
    copper: 'Kupfer',
    brass: 'Messing',
    cast_iron: 'Gusseisen',
    zinc: 'Zink',
    nylon: 'Nylon',
    abs: 'ABS',
    pla: 'PLA',
    pom: 'POM (Delrin)',
    acrylic: 'Acryl',
    pc: 'Polycarbonat',
    oak: 'Eiche',
    pine: 'Kiefer',
    glass: 'Glas',
    ceramic: 'Keramik',
  },
  weight: {
    hollow: 'Hohl',
    solid: 'Massiv',
    thickness: 'Stärke',
    mm: 'mm',
  },
  viewer: {
    leftView: 'Linke Ansicht',
    rightView: 'Rechte Ansicht',
  },
  loading: {
    modelLoading: 'Modell wird geladen...',
    loadingPercent: 'Laden {percent}%',
  },
  dropHint: {
    text: 'Modelldatei ablegen (.stl / .obj / .ply / .gltf / .glb / .fbx / .step / .iges / .brep)',
  },
  title: '3D Viewer',
}
